const getDevelopmentConfig = () => ({
  auth: {
    clientId: process.env.REACT_APP_OUTLOOK_CLIENT_ID,
    redirectUri: window.location.origin + window.location.pathname,
    authority: 'https://login.microsoftonline.com/common',
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false
  },
  system: {
    allowRedirectInIframe: true,
    loggerOptions: {
      loggerCallback: () => {},
      logLevel: 0
    }
  }
});

export const getMsalConfig = () => {
  return getDevelopmentConfig();
};
